/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Product } from "./Product";
export const ProductsResponse = core.serialization.object({
    data: core.serialization.list(Product),
});
